/**
 * Données détaillées des pays (Wikidata) pour les modes du Lab : population,
 * superficie, frontières, domaine internet, indicatif (`country-details.json`),
 * monnaies, langues et gentilés dans la langue du site
 * (`country-details-{lang}.json`). Chargées à la demande, une seule fois, par
 * les seules pages qui s'en servent (les autres n'ont pas à payer ces ~100 Ko).
 *
 * @returns {Promise<Object<string, object>>} `{ code: { population, area, borders, tld, phone, currencies, languages, … } }`
 */
let promise = null;

export function loadCountryDetails(lang = "fr") {
	if (!promise) {
		const get = (url) => fetch(url).then(r => {
			if (!r.ok) throw new Error(`HTTP ${r.status}`);
			return r.json();
		});
		promise = Promise.all([get("/data/country-details.json"), get(`/data/country-details-${lang}.json`)])
			.then(([neutral, localized]) => {
				const out = {};
				for (const code of Object.keys(neutral)) {
					if (code.startsWith("_")) continue;
					out[code] = { ...neutral[code], ...(localized[code] || {}) };
				}
				return out;
			})
			.catch((e) => {
				promise = null;
				throw e;
			});
	}
	return promise;
}

/** Pour les tests : fournit les données sans réseau. */
export function _setCountryDetails(details) {
	promise = Promise.resolve(details);
}
